<div class="mapping-layout" id="manufacturerMappingLayout">
  <dx-load-panel [visible]="aiMappingRunning"
                 [delay]="1000"
                 [position]="{ of: '#manufacturerMappingLayout' }"
                 [hideOnOutsideClick]="false"
                 [message]="'Automatische Zuordnung läuft...' | translate">
  </dx-load-panel>

  <div class="dx-card mapping-card card-left">
    <div class="card-header">
      <div class="title">Importkatalog</div>
      <p class="importCatalogName">{{importCatalog?.catalogName}}</p>
    </div>
  </div>

  <div class="dx-card mapping-card card-right">
    <div class="card-header">
      <div class="title">Golden Record</div>

      <div class="card-header-button">
        <np-ai-button [text]="'Automatisch zuordnen' | translate"
                      [disabled]="aiMappingRunning"
                      (clicked)="onAutoMap()">
        </np-ai-button>
      </div>

      <div class="card-header__bottom">
        <dx-check-box text="Zugeordnet" [(value)]="showMapped" (onValueChanged)="onToggleFilter('showMapped', $event)"></dx-check-box>
        <dx-check-box text="Nicht zugeordnet" [(value)]="showUnmapped" (onValueChanged)="onToggleFilter('showUnmapped', $event)"></dx-check-box>
      </div>
    </div>
  </div>

  <div class="rows-wrapper">
    <dx-scroll-view class="rows-scroll-view" direction="vertical" [useNative]="true">
      <div class="rows-container">

        <div class="mapping-row" *ngFor="let row of filteredRows">

          <div class="cell cell--import">
            <div class="item-box item-box--left">
              <!--<span class="status-indicator status-middle"></span>-->
              <span class="item-label">{{ row.importManufacturerName || 'n/a' }}</span>
            </div>
          </div>

         <div class="cell cell--arrow">
            <div class="arrow arrow--right"></div>
          </div>

          <div class="cell cell--golden">
            <div class="item-box item-box--right">
              <dx-select-box
                class="golden-select"
                [items]="dataSources"
                displayExpr="name"
                valueExpr="id"
                [(value)]="row.datasource!.selectedId"
                (onValueChanged)="onDataSourceChanged($event, row)"
                [disabled]="row.datasource.readonly"
                [dropDownOptions]="dropDownCfg"
                [searchEnabled]="true">
                <div *dxTemplate="let d of 'addSourceToolbarButton'">
                  <dx-button
                    icon="plus"
                    stylingMode="text"
                    hint="Datenquelle hinzufügen"
                    (onClick)="addNewSource()">
                  </dx-button>
                </div>

              </dx-select-box>
            </div>

          </div>

        </div>

      </div>
    </dx-scroll-view>
  </div>
  <np-edit-datasource
    [(visible)]="popupVisible"
    [editMode]="false"
    [dataSource]="newAddedDatasource"
    (saved)="onEditSaved($event)"
  ></np-edit-datasource>

</div>
